import { api, unwrap, type APIResponse } from "./client";
import type { Node, Edge } from "@xyflow/react";

export interface IVRFlowSummary {
  ivr_flow_id: number;
  name: string;
  description: string | null;
  is_active: boolean;
}

export interface IVRDefinition {
  nodes: Node[];
  edges: Edge[];
}

export interface IVRFlowDetail extends IVRFlowSummary {
  definition: IVRDefinition;
}

export interface IVRFlowSave {
  name: string;
  description?: string | null;
  definition: IVRDefinition;
}

export async function listIvrFlows(): Promise<IVRFlowSummary[]> {
  const resp = await api.get<APIResponse<IVRFlowSummary[]>>("/ivr/");
  return unwrap(resp.data);
}

export async function getIvrFlow(id: number): Promise<IVRFlowDetail> {
  const resp = await api.get<APIResponse<IVRFlowDetail>>(`/ivr/${id}`);
  return unwrap(resp.data);
}

export async function createIvrFlow(body: IVRFlowSave): Promise<number> {
  const resp = await api.post<APIResponse<{ ivr_flow_id: number }>>("/ivr/", body);
  return unwrap(resp.data).ivr_flow_id;
}

export async function updateIvrFlow(id: number, body: IVRFlowSave): Promise<void> {
  const resp = await api.put<APIResponse<{ updated: boolean }>>(`/ivr/${id}`, body);
  unwrap(resp.data);
}
